import CrudCustom from '../../../libs/custom/CrudCustom';

let NegaraService = new CrudCustom('/negaras');
export default NegaraService;
